import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import Navbar from 'react-bootstrap/lib/Navbar'
import Nav from 'react-bootstrap/lib/Nav'
import NavItem from 'react-bootstrap/lib/NavItem'
import Row from 'react-bootstrap/lib/Row'
import Col from 'react-bootstrap/lib/Col'

import { useNavigate, useLocation, Link } from 'react-router-dom'
import PropTypes from 'prop-types'
import _some from 'lodash/some'

import * as actions from './../../actions/userActions'
import utilIsUnderwriter from '../../utils/is-underwriter'
import Logo from '../shared/Logo'
import routes from './../../constants/routes'
import { OKTA_VERSIONS } from '../../constants'
import { useOktaAuth } from '@okta/okta-react'

const HIDE_NAVBAR = [
  routes.IMPLICIT_CALLBACK,
  routes.COMPLETE_INVITE,
  routes.COMPLETE_PROFILE,
]

export function Header(props) {
  const { oktaAuth, authState } = useOktaAuth()
  const navigate = useNavigate()
  const location = useLocation()
  const pathname = location.pathname

  const [name, setName] = useState('')
  const { user } = props

  useEffect(() => {
    const fetchUser = async () => {
      try {
        if (authState?.isAuthenticated) {
          const userData = await oktaAuth.getUser()
          setName(userData.name ?? '')
        } else {
          setName('')
        }
      } catch (err) {
        console.error(err)
      }
    }
    fetchUser()
  }, [oktaAuth, authState?.isAuthenticated])

  const isUnderwriter = user && user.role ? utilIsUnderwriter(user) : false

  const canManageUsers = () => {
    if (!user || !user.role) return false
    if (user.role.includes('admin')) return true
    if (!user.permissions) return false
    return _some([
      user.permissions.includes('underwriters:write'),
      user.permissions.includes('brokers:write'),
    ])
  }

  const canManageBrokerages = () => {
    if (!user || !user.permissions) return false
    return _some([
      user.permissions.includes('brokers:read'),
      user.permissions.includes('brokers:write'),
    ])
  }

  const logout = async () => {
    try {
      await oktaAuth.signOut()
      if (OE_ENV.OKTA_VERSION !== OKTA_VERSIONS.V2) {
        navigate('/login')
      }
    } catch (error) {
      console.log(error)
    }
  }

  if (HIDE_NAVBAR.includes(pathname)) return null

  // Custom helper to handle navigation without LinkContainer
  const handleNav = (to) => (e) => {
    e.preventDefault();
    navigate(to);
  };

  return (
    <Navbar fluid className="navbar-default">
      <div className="container-fluid">
        <Navbar.Header>
          <Row>
            <Col xs={10} sm={8}>
              <Navbar.Brand>
                <Link to="/submissions">
                  <Logo className="logo" />
                  <h1>Owner&apos;s Edge</h1>
                </Link>
              </Navbar.Brand>
            </Col>
            <Col xs={2}>
              <Navbar.Toggle />
            </Col>
          </Row>
        </Navbar.Header>

        <Navbar.Collapse>
          <Nav pullRight>
            {name && (
              <NavItem href="/submissions" onClick={handleNav('/submissions')}>
                Submissions
              </NavItem>
            )}

            {!name && (
              <NavItem href="/login" onClick={handleNav('/login')}>
                Login
              </NavItem>
            )}

            {canManageBrokerages() && (
              <NavItem href="/brokerages" onClick={handleNav('/brokerages')}>
                {isUnderwriter ? 'Brokers' : 'Brokerages'}
              </NavItem>
            )}

            {canManageUsers() && (
              <NavItem href="/users" onClick={handleNav('/users')}>
                {isUnderwriter ? 'Underwriters' : 'Manage Users'}
              </NavItem>
            )}

            {name && (
              <NavItem href="/faq" onClick={handleNav('/faq')}>
                FAQ
              </NavItem>
            )}

            {name && authState?.isAuthenticated && (
              <NavItem onClick={logout} className="last">
                Log out
              </NavItem>
            )}
          </Nav>
        </Navbar.Collapse>
      </div>
    </Navbar>
  )
}

Header.propTypes = {
  user: PropTypes.object,
}

export default connect(
  (store) => ({
    user: store.user,
  }),
  actions,
)(Header)
